import { getAllEvents, getEventCount, getMenus } from "../../src/lib/dataFetch";
import parse from "html-react-parser";
import { default as NextLink } from "next/link";
import { Stack, StackDivider } from "@chakra-ui/react";
import Layout from "../../src/components/layout";
import Seo from "../../src/components/seo";
import EventCard from "../../src/components/EventCard";

export default function EventsIndex({ events, menus, eventsSorted, pageInfo }) {
  console.log(pageInfo)
  return (
    <Layout
      menus={menus}
      hasNext={pageInfo?.hasNextPage}
      hasPrevious={pageInfo?.hasPreviousPage}
      startCursor={pageInfo?.startCursor}
      endCursor={pageInfo?.endCursor}
    >
      <Seo title="Upcoming Events" />
      <Stack
        as="ol"
        divider={<StackDivider borderColor="gray.200" />}
        spacing={4}
        mb={4}
        p={8}
        listStyleType="none"
      >
        {events.map((event, index) => {
          const title = event.title;
          const featuredImage = {
            src: event.featuredImage?.node?.sourceUrl,
            alt: event.featuredImage?.node?.alt || ``,
          };

          return (
            <>
              <EventCard
                key={event.uri}
                title={title}
                featuredImage={featuredImage}
                uri={event.uri}
                categories={event.eventsCategories.nodes}
                excerpt={event.excerpt}
                date={event.startDate}
              />
            </>
          );
        })}
      </Stack>
    </Layout>
  );
}
export async function getStaticProps(context) {
  const data = await getAllEvents();
  const menus = await getMenus();
  const eventsSorted = data.events.sort((a, b) => {
    let da = new Date(a.startDate);
    let db = new Date(b.startDate);
    return da - db;
  });
  const sliceStart = (context.params.slug - 1) * 10;
  const events = eventsSorted.slice(sliceStart, sliceStart + 10);
  const hasNextPage = Number(context.params.slug) < eventsSorted.length / 10;
  const hasPreviousPage = Number(context.params.slug) <= eventsSorted.length / 10;
  const pageInfo = {
    __typename: "WPPageInfo",
    hasNextPage: hasNextPage,
    hasPreviousPage: true,
    startCursor: null,
    endCursor: null,
  };
  console.log(Number(context.params.slug))
  return {
    props: {
      events,
      menus,
      eventsSorted,
      pageInfo,
    },
  };
}

export async function getStaticPaths() {
  const events = await getEventCount();
  const pages = events.length;
  let paths = [];

  for (let i = 1; i < pages; i++) {
    paths = paths.concat({ params: { slug: `${i + 1}` } });
  }
  return { paths, fallback: false };
}
